{
  "eyebrow": "Patvirtinkite planą",
  "title": "Peržiūrėkite ir sukonfigūruokite.",
  "sub": "Atsiskaitymo ciklą ar planą galite pakeisti bet kada administratoriaus skydelyje.",
  "yourPlan": "Jūsų planas",
  "changePlan": "Keisti planą",
  "billing": "Atsiskaitymo ciklas",
  "billingMonthLabel": "Mokėti kas mėnesį",
  "billingMonthDesc": "Lankstu. Atšaukite bet kada.",
  "billingYearLabel": "Mokėti kasmet",
  "billingYearDesc": "15% nuolaida. Atsiskaitoma kartą per metus.",
  "addons": "Priedai",
  "addon": {
    "ssec": "Socialinis draudimas (check-in/out@work)",
    "ssecDesc": "Tik Belgija — automatinė Dimona deklaracija.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Tiesioginis GPS įmonės transporto priemonėms. +4 €/transporto priemonė/mėn.",
    "vehicles": "Transporto priemonės"
  },
  "employees": {
    "title": "Kiek darbuotojų?",
    "active": "naudotojų",
    "popular": "Daugumai komandų tinka {{n}}"
  },
  "estimate": "Numatoma mėnesinė kaina",
  "estimateNote": "Be PVM. Mokate už čia nurodytą naudotojų skaičių ir vėliau galite jį pakeisti.",
  "estimateUnavailable": "Kainoraštis nepasiekiamas. Bandykite dar kartą, kad būtų įkelti naujausi kainos."
}
